import Loader from '../../../components/Loader/Loader.component';
import React, { useCallback, useState } from 'react';
import { Prompt } from '../../../components/Prompt/Prompt.component';
import { disableExaminingTeamInExaminersTreemap } from '../../../services/exams/assessmentSession/assessments.service';

export const DisableExaminingTeam: React.FC<{
  examiningTeamId: string;
  onSuccess: () => void;
  onFailure: () => void;
}> = (props) => {
  const [openSuccessPrompt, setOpenSuccessPrompt] = useState<boolean>(false);
  const [openFailurePrompt, setOpenFailurePrompt] = useState<boolean>(false);
  const [openConfirmationPrompt, setOpenConfirmationPrompt] = useState<boolean>(true);
  const [isLoaderVisible, setIsLoaderVisible] = useState<boolean>(false);

  const disableSelectedExaminer = useCallback(() => {
    setIsLoaderVisible(true);
    setOpenConfirmationPrompt(false);
    disableExaminingTeamInExaminersTreemap(props.examiningTeamId)
      .then(
        () => {
          setOpenSuccessPrompt(true);
        },
        () => {
          setOpenFailurePrompt(true);
        },
      )
      .finally(() => {
        setIsLoaderVisible(false);
      });
  }, [props.examiningTeamId]);

  const getPromptSubTexts = (isSuccess?: boolean) => {
    return [
      {
        text: isSuccess ? 'zakończone sukcesem.' : 'nie powiodło się, spróbuj ponownie później.',
        isBold: true,
      },
    ];
  };

  return (
    <>
      {isLoaderVisible && <Loader />}
      <Prompt
        type="confirmation"
        isBold={true}
        open={openConfirmationPrompt}
        mainText={'Czy na pewno chcesz zablokować Zespół Egzaminacyjny?'}
        subTexts={[
          {
            text: '(Zablokowanie Egzaminatora nie dotyczy pobranych lub ocenianych już rozwiąząń zadań)',
            isBold: true,
          },
        ]}
        onConfirm={disableSelectedExaminer}
        onCancel={props.onFailure}
        mainActionButtonText="TAK"
      />
      <Prompt
        type="error"
        isBold={true}
        open={openFailurePrompt}
        mainText={'Zablokowanie Zespołu Egzaminacyjnego'}
        subTexts={getPromptSubTexts(false)}
        onConfirm={props.onFailure}
        mainActionButtonText="POWRÓT DO LISTY"
      />
      <Prompt
        type="success"
        isBold={true}
        open={openSuccessPrompt}
        mainText={'Zablokowanie Zespołu Egzaminacyjnego'}
        subTexts={getPromptSubTexts(true)}
        onConfirm={props.onSuccess}
        mainActionButtonText="POWRÓT DO LISTY"
      />
    </>
  );
};
